var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"game-container"},[(_vm.$route.name !== 'GenerateDeck')?_c('div',{staticClass:"phone-spacer"}):_vm._e(),_c('router-view'),_c('br'),_c('div',{staticClass:"phone-spacer"}),(_vm.$route.name === 'play')?_c('GameControls'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }